const BREAKPOINTS = {
  MD_GRID: 576,
  LG_GRID: 992,
  XL_GRID: 1440,
};

export default BREAKPOINTS;
